export const getPageNumbers = (count, itemsPerPage) => {
	// Input validation
	if (!Number.isInteger(count) || !Number.isInteger(itemsPerPage)) {
		throw new Error('Count and itemsPerPage must be integers');
	}
	if (count < 0 || itemsPerPage <= 0) {
		throw new Error(
			'Count must be non-negative and itemsPerPage must be positive',
		);
	}

	const totalPages = Math.ceil(count / itemsPerPage);

	if (totalPages === 0) return [];

	return Array.from({ length: totalPages }, (_, index) => index + 1);
};
